module.exports = __webpack_public_path__ + "img/profile.9db9fac0.svg";